module.exports = __webpack_public_path__ + "img/work.6276ecd.png";